export default __webpack_public_path__ + "static/media/send-message.02ee4339.png";